import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import { markInputRule, MarkGroup, isElementDOMNode, isString, MarkExtension, markPasteRule, getSelectedWord, updateMark, removeMark, selectionEmpty, isTextSelection, isMarkActive, getMatchString, getMarkRange, Cast, Extension, ZERO_WIDTH_SPACE_CHAR, uniqueArray, toggleWrap, EDITOR_CLASS_SELECTOR, NodeGroup, NodeExtension, toggleList, toggleBlockItem, nodeInputRule, clamp, Tags, DocExtension, TextExtension } from '@remirror/core';
import { toggleMark, chainCommands, baseKeymap, selectParentNode, exitCode, setBlockType } from 'prosemirror-commands';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { TextSelection, Plugin, Selection } from 'prosemirror-state';
import { undoInputRule, wrappingInputRule, textblockTypeInputRule } from 'prosemirror-inputrules';
import { Cast as Cast$1, isAndroidOS, isInstanceOf, isString as isString$1, isNumber, isArray, uniqueArray as uniqueArray$1, entries } from '@remirror/core-helpers';
import { getPluginState, nodeNameMatchesList, isTextSelection as isTextSelection$1, environment, isDocNodeEmpty, getPluginMeta, nodeEqualsType } from '@remirror/core-utils';
import { dropCursor } from 'prosemirror-dropcursor';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import { css, getElementProps, cloneElement, isReactFragment, isReactDOMElement } from '@remirror/react-utils';
import { gapCursor, GapCursor } from 'prosemirror-gapcursor';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import { redo, undo, history, redoDepth, undoDepth } from 'prosemirror-history';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { Children } from 'react';
import { jsx } from '@emotion/core';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { splitListItem, sinkListItem, liftListItem } from 'prosemirror-schema-list';

var BoldExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(BoldExtension, _MarkExtension);

  function BoldExtension() {
    _classCallCheck(this, BoldExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(BoldExtension).apply(this, arguments));
  }

  _createClass(BoldExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-b': toggleMark(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return {
        bold: function bold() {
          return toggleMark(type);
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [markInputRule({
        regexp: /(?:\*\*|__)([^*_]+)(?:\*\*|__)$/,
        type: type
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'bold';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: MarkGroup.FontStyle,
        parseDOM: [{
          tag: 'strong'
        }, // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
          tag: 'b',
          getAttrs: function getAttrs(node) {
            return isElementDOMNode(node) && node.style.fontWeight !== 'normal' ? null : false;
          }
        }, {
          style: 'font-weight',
          getAttrs: function getAttrs(node) {
            return isString(node) && /^(bold(er)?|[5-9]\d{2,})$/.test(node) ? null : false;
          }
        }],
        toDOM: function toDOM() {
          return ['strong', 0];
        }
      };
    }
  }]);

  return BoldExtension;
}(MarkExtension);

var CodeExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(CodeExtension, _MarkExtension);

  function CodeExtension() {
    _classCallCheck(this, CodeExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeExtension).apply(this, arguments));
  }

  _createClass(CodeExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-`': toggleMark(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return {
        code: function code() {
          return toggleMark(type);
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [markInputRule({
        regexp: /(?:`)([^`]+)(?:`)$/,
        type: type
      })];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [markPasteRule({
        regexp: /(?:`)([^`]+)(?:`)/g,
        type: type
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'code';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: MarkGroup.Code,
        parseDOM: [{
          tag: 'code'
        }],
        toDOM: function toDOM() {
          return ['code', 0];
        }
      };
    }
  }]);

  return CodeExtension;
}(MarkExtension);

var ItalicExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(ItalicExtension, _MarkExtension);

  function ItalicExtension() {
    _classCallCheck(this, ItalicExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItalicExtension).apply(this, arguments));
  }

  _createClass(ItalicExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-i': toggleMark(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return {
        italic: function italic() {
          return toggleMark(type);
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [markInputRule({
        regexp: /(?:^|[^*_])(?:\*|_)([^*_]+)(?:\*|_)$/,
        type: type
      })];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [markPasteRule({
        regexp: /(?:^|[^*_])(?:\*|_)([^*_]+)(?:\*|_)/g,
        type: type
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'italic';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: MarkGroup.FontStyle,
        parseDOM: [{
          tag: 'i'
        }, {
          tag: 'em'
        }, {
          style: 'font-style=italic'
        }],
        toDOM: function toDOM() {
          return ['em', 0];
        }
      };
    }
  }]);

  return ItalicExtension;
}(MarkExtension);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var LinkExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(LinkExtension, _MarkExtension);

  function LinkExtension() {
    _classCallCheck(this, LinkExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkExtension).apply(this, arguments));
  }

  _createClass(LinkExtension, [{
    key: "keys",
    value: function keys() {
      var _this = this;

      return {
        'Mod-k': function ModK(state, dispatch) {
          // Expand selection
          var range = getSelectedWord(state);

          if (!range) {
            return false;
          }

          var from = range.from,
              to = range.to;
          var tr = state.tr.setSelection(TextSelection.create(state.doc, from, to));

          if (dispatch) {
            dispatch(tr);
          }

          _this.options.activationHandler();

          return true;
        }
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return {
        /**
         * A command to update the selected link
         */
        updateLink: function updateLink(attrs) {
          return updateMark({
            type: type,
            attrs: attrs
          });
        },

        /**
         * Remove the link at the current position
         */
        removeLink: function removeLink() {
          return removeMark({
            type: type,
            expand: true
          });
        }
      };
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(_ref2) {
      var getState = _ref2.getState,
          type = _ref2.type;
      return function (_ref3) {
        var command = _ref3.command;

        switch (command) {
          case 'removeLink':
            return isMarkActive({
              state: getState(),
              type: type
            });

          case 'updateLink':
            {
              var _getState = getState(),
                  selection = _getState.selection;

              if (selectionEmpty(selection) || !isTextSelection(selection)) {
                return false;
              }

              return true;
            }

          default:
            return true;
        }
      };
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [markPasteRule({
        regexp: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
        type: type,
        getAttrs: function getAttrs(url) {
          return {
            href: getMatchString(url)
          };
        }
      })];
    }
  }, {
    key: "plugin",
    value: function plugin(_ref5) {
      var type = _ref5.type;
      return new Plugin({
        props: {
          handleClick: function handleClick(view, pos) {
            var _view$state = view.state,
                doc = _view$state.doc,
                tr = _view$state.tr;
            var range = getMarkRange(doc.resolve(pos), type);

            if (!range) {
              return false;
            }

            var $start = doc.resolve(range.from);
            var $end = doc.resolve(range.to);
            var transaction = tr.setSelection(new TextSelection($start, $end));
            view.dispatch(transaction);
            return true;
          }
        }
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'link';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        activationHandler: function activationHandler() {
          return false;
        }
      };
    }
  }, {
    key: "schema",
    get: function get() {
      var _this2 = this;

      return {
        group: MarkGroup.Link,
        attrs: _objectSpread({}, this.extraAttrs(null), {
          href: {
            default: null
          }
        }),
        inclusive: false,
        parseDOM: [{
          tag: 'a[href]',
          getAttrs: function getAttrs(node) {
            return _objectSpread({
              href: Cast(node).getAttribute('href')
            }, _this2.getExtraAttrs(Cast(node)));
          }
        }],
        toDOM: function toDOM(node) {
          return ['a', _objectSpread({}, node.attrs, {
            rel: 'noopener noreferrer nofollow'
          }), 0];
        }
      };
    }
  }]);

  return LinkExtension;
}(MarkExtension);

var StrikeExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(StrikeExtension, _MarkExtension);

  function StrikeExtension() {
    _classCallCheck(this, StrikeExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(StrikeExtension).apply(this, arguments));
  }

  _createClass(StrikeExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-d': toggleMark(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return {
        strike: function strike() {
          return toggleMark(type);
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [markInputRule({
        regexp: /~([^~]+)~$/,
        type: type
      })];
    }
  }, {
    key: "pasteRules",
    value: function pasteRules(_ref4) {
      var type = _ref4.type;
      return [markPasteRule({
        regexp: /~([^~]+)~/g,
        type: type
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'strike';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: MarkGroup.FontStyle,
        parseDOM: [{
          tag: 's'
        }, {
          tag: 'del'
        }, {
          tag: 'strike'
        }, {
          style: 'text-decoration',
          getAttrs: function getAttrs(node) {
            return node === 'line-through' ? {} : false;
          }
        }],
        toDOM: function toDOM() {
          return ['s', 0];
        }
      };
    }
  }]);

  return StrikeExtension;
}(MarkExtension);

var UnderlineExtension =
/*#__PURE__*/
function (_MarkExtension) {
  _inherits(UnderlineExtension, _MarkExtension);

  function UnderlineExtension() {
    _classCallCheck(this, UnderlineExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnderlineExtension).apply(this, arguments));
  }

  _createClass(UnderlineExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        'Mod-u': toggleMark(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return {
        underline: function underline() {
          return toggleMark(type);
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'underline';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        group: MarkGroup.FontStyle,
        parseDOM: [{
          tag: 'u'
        }, {
          style: 'text-decoration',
          getAttrs: function getAttrs(node) {
            return node === 'underline' ? {} : false;
          }
        }],
        toDOM: function toDOM() {
          return ['u', 0];
        }
      };
    }
  }]);

  return UnderlineExtension;
}(MarkExtension);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultBaseKeymapExtensionOptions = {
  undoInputRuleOnBackspace: true,
  selectParentNodeOnEscape: false
};
/**
 * Provides the expected default key mappings to the editor.
 *
 * @remarks
 *
 * Without this extension most of the shortcuts and behaviours we have come to
 * expected from text editors would not be provided.
 *
 * @builtin
 */

var BaseKeymapExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(BaseKeymapExtension, _Extension);

  function BaseKeymapExtension() {
    _classCallCheck(this, BaseKeymapExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseKeymapExtension).apply(this, arguments));
  }

  _createClass(BaseKeymapExtension, [{
    key: "keys",

    /**
     * Injects the baseKeymap into the editor.
     */
    value: function keys() {
      var _this$options = this.options,
          selectParentNodeOnEscape = _this$options.selectParentNodeOnEscape,
          undoInputRuleOnBackspace = _this$options.undoInputRuleOnBackspace;
      var backspaceRule = undoInputRuleOnBackspace ? {
        Backspace: chainCommands(undoInputRule, baseKeymap.Backspace)
      } : {};
      var escapeRule = selectParentNodeOnEscape ? {
        Escape: selectParentNode
      } : {};
      return _objectSpread$1({}, baseKeymap, {}, backspaceRule, {}, escapeRule);
    }
  }, {
    key: "name",
    get: function get() {
      return 'baseKeymap';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultBaseKeymapExtensionOptions;
    }
  }]);

  return BaseKeymapExtension;
}(Extension);

/**
 * Used to denote a node is empty.
 *
 * Currently used by the placeholder extension.
 */
var EMPTY_NODE_CLASS_NAME = 'is-empty';
var EMPTY_NODE_CLASS_SELECTOR = ".".concat(EMPTY_NODE_CLASS_NAME);
/**
 * A list of nodes that need special treatment for composition events on android and also for
 * arrow key presses between items in general. Used by both the CompositionExtension and NodeCursorExtension
 */

var NODE_CURSOR_DEFAULTS = ['emoji'];

/**
 * Manages the composition state of the editor.
 *
 * TODO verify that this is still necessary with `prosemirror-view@1.9.0`
 */
var CompositionState =
/*#__PURE__*/
function () {
  function CompositionState() {
    _classCallCheck(this, CompositionState);

    _defineProperty(this, "deleteInProgress", false);

    _defineProperty(this, "decorationTicks", 0);

    _defineProperty(this, "active", false);

    _defineProperty(this, "lastTransactionFiltered", false);
  }

  _createClass(CompositionState, [{
    key: "init",

    /**
     * Used to store a reference to the view. This is necessary because the plugin state
     * is constructed within the prosemirror `state.init` which doesn't yet have access to the view.
     *
     * This should be called from within the view hook in the prosemirror plugin.
     *
     * @param view - the editor view
     */
    value: function init(view) {
      this.view = view;
      return this;
    }
    /**
     * Used to indicated a delete is now in progress
     */

  }, {
    key: "startDelete",
    value: function startDelete() {
      this.deleteInProgress = true;
      this.active = true;
      return this;
    }
    /**
     * Used to indicated that a delete has now finished.
     *
     * @param selection - the current selection
     */

  }, {
    key: "endDelete",
    value: function endDelete(selection) {
      this.deleteInProgress = false;
      this.selection = selection;
      return this;
    }
    /**
     * Reset the state of the plugin to it's initial settings.
     */

  }, {
    key: "resetState",
    value: function resetState() {
      this.active = false;
      this.deleteInProgress = false;
      this.selection = undefined;
      this.lastTransactionFiltered = false;
      return this;
    }
    /**
     * Used in the plugin to reset the state after a transaction has been filtered
     */

  }, {
    key: "apply",
    value: function apply() {
      if (this.lastTransactionFiltered) {
        this.resetState();
      }

      return this;
    }
    /**
     * Appends a transaction  to the state only when there is a selection and the composition delete has finished.
     *
     * @param transactions - a list of transactions
     */

  }, {
    key: "appendTransaction",
    value: function appendTransaction(transactions) {
      if (this.lastTransactionFiltered) {
        return undefined;
      }

      if (transactions.length !== 1) {
        return undefined;
      }

      var tr = transactions[0];

      if (!tr.steps.length && this.active && !this.deleteInProgress && this.selection) {
        this.lastTransactionFiltered = true;
        return tr.setSelection(this.selection);
      }

      return undefined;
    }
    /**
     * Currently this is not in use but should be tested to see if it works
     *
     * TODO use this instead of append transaction but this time filter the transaction which
     * happens while the delete is in progress (return false) and see if that prevents the extra
     * delete on android devices
     *
     * @param tr - a prosemirror transaction
     */

  }, {
    key: "filterTransaction",
    value: function filterTransaction(tr) {
      if (this.lastTransactionFiltered) {
        return true;
      }

      if (!tr.steps.length && this.active && !this.deleteInProgress && this.selection) {
        this.lastTransactionFiltered = true;
        this.view.dispatch(tr.setSelection(this.selection));
        this.resetState();
      }

      return true;
    }
  }]);

  return CompositionState;
}();

/**
 * Improve android composition handling.
 *
 * @remarks
 *
 * Borrowed from https://bitbucket.org/atlassian/atlaskit-mk-2/src/14c0461025a93936d83117ccdd5b34e3623b7a16/packages/editor/editor-core/src/plugins/composition/events/deleteContentBackward.ts?at=master&fileviewer=file-view-default
 *
 * This should be called on a `beforeinput` event.
 *
 * Android composition events aren't handled well by Prosemirror
 * We've added a couple of beforeinput hooks to help PM out when trying to delete
 * certain nodes. We can remove these when PM has better composition support.
 * ~~@see https://github.com/ProseMirror/prosemirror/issues/543~~ **FIXED**
 * @see https://github.com/ProseMirror/prosemirror/issues/837
 */

var patchDeleteContentBackward = function patchDeleteContentBackward(options, view, event, pluginState) {
  var state = view.state,
      dispatch = view.dispatch;
  var $from = state.selection.$from;
  var ensureNodeDeletion = options.ensureNodeDeletion;
  var tr = state.tr,
      selection = state.selection;
  /**
   * If text contains marks, composition events won't delete any characters.
   */

  if ($from.nodeBefore && $from.nodeBefore.type.name === 'text' && $from.nodeBefore.marks.length) {
    event.preventDefault();
    dispatch(tr.delete($from.pos - 1, $from.pos).setSelection(Selection.near(tr.doc.resolve(tr.mapping.map($from.pos - 1)))));
    return true;
  }
  /**
   * This block caters for the standard composition backspace.
   * We check to see if the previous node is one we want to ensure is deleted
   */


  if ($from.nodeBefore && nodeNameMatchesList($from.nodeBefore, ensureNodeDeletion)) {
    event.preventDefault();
    tr.delete($from.pos - $from.nodeBefore.nodeSize, $from.pos);
    var newSelection = Selection.near(tr.doc.resolve(tr.mapping.map($from.pos - $from.nodeBefore.nodeSize)));
    tr.setSelection(newSelection);
    dispatch(tr);
    pluginState.endDelete(newSelection);
    return true;
  }
  /**
   * This block caters for highlighting the defined nodes when a selection has been made
   */


  if (isTextSelection$1(selection) && selection.$cursor === null && $from.nodeAfter && nodeNameMatchesList($from.nodeBefore, ensureNodeDeletion)) {
    event.preventDefault();
    dispatch(state.tr.deleteSelection());
    return true;
  }

  return false;
};
/**
 * Creates the plugin for composition.
 *
 * @remarks
 *
 * "Borrowed" from `@atlaskit`
 *
 * A workaround or composition events when using `gboard` on Android.
 *
 * Ideally this plugin should be deleted once Composition events are handled correctly.
 * TODO verify whether it can be deleted
 *
 * @see https://www.w3.org/TR/input-events-2/
 *
 */

var createCompositionPlugin = function createCompositionPlugin(ctx) {
  return new Plugin({
    key: ctx.pluginKey,
    appendTransaction: function appendTransaction(transactions, _b, state) {
      return getPluginState(ctx.pluginKey, state).appendTransaction(transactions);
    },
    state: {
      init: function init() {
        return new CompositionState();
      },
      apply: function apply(_, pluginState) {
        return pluginState.apply();
      }
    },
    view: function view(_view) {
      getPluginState(ctx.pluginKey, _view.state).init(_view);
      return {};
    },
    props: {
      handleDOMEvents: {
        /**
         * Borrowed from https://bitbucket.org/atlassian/atlaskit-mk-2/src/14c0461025a93936d83117ccdd5b34e3623b7a16/packages/editor/editor-core/src/plugins/composition/index.ts?at=master&fileviewer=file-view-default
         *
         * Android composition events aren't handled well by Prosemirror
         * We've added a couple of beforeinput hooks to help PM out when trying to delete
         * certain nodes. We can remove these when PM has better composition support.
         * @see https://github.com/ProseMirror/prosemirror/issues/543
         */
        beforeinput: function beforeinput(view, ev) {
          var event = Cast$1(ev);

          if (event.inputType === 'deleteContentBackward' && isAndroidOS()) {
            var pluginState = getPluginState(ctx.pluginKey, view.state);
            pluginState.startDelete();
            return patchDeleteContentBackward(ctx.options, view, event, pluginState);
          }

          return true;
        }
      }
    }
  });
};

/**
 * This allow composition events to delete inline nodes using gboard on Android devices.
 *
 * @builtin
 */

var CompositionExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(CompositionExtension, _Extension);

  function CompositionExtension() {
    _classCallCheck(this, CompositionExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompositionExtension).apply(this, arguments));
  }

  _createClass(CompositionExtension, [{
    key: "plugin",
    value: function plugin() {
      return createCompositionPlugin(this);
    }
  }, {
    key: "name",
    get: function get() {
      return 'composition';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        ensureNodeDeletion: NODE_CURSOR_DEFAULTS
      };
    }
  }]);

  return CompositionExtension;
}(Extension);

var defaultDropCursorExtensionOptions = {
  color: 'black',
  width: 1
};
/**
 * Create a plugin that, when added to a ProseMirror instance,
 * causes a decoration to show up at the drop position when something
 * is dragged over the editor.
 *
 * @builtin
 */

var DropCursorExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(DropCursorExtension, _Extension);

  function DropCursorExtension() {
    _classCallCheck(this, DropCursorExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropCursorExtension).apply(this, arguments));
  }

  _createClass(DropCursorExtension, [{
    key: "plugin",

    /**
     * Use the dropCursor plugin with provided options.
     */
    value: function plugin() {
      var _this$options = this.options,
          color = _this$options.color,
          width = _this$options.width;
      return dropCursor({
        color: color,
        width: width
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'dropCursor';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultDropCursorExtensionOptions;
    }
  }]);

  return DropCursorExtension;
}(Extension);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      .ProseMirror-gapcursor {\n        display: none;\n        pointer-events: none;\n        position: absolute;\n      }\n\n      .ProseMirror-gapcursor:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: -2px;\n        width: 20px;\n        border-top: 1px solid black;\n        animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n      }\n\n      @keyframes ProseMirror-cursor-blink {\n        to {\n          visibility: hidden;\n        }\n      }\n\n      .ProseMirror-focused .ProseMirror-gapcursor {\n        display: block;\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Create a gap cursor plugin.
 *
 * @remarks
 *
 * When enabled, this will capture clicks near and arrow-key-motion past places
 * that don't have a normally selectable position nearby, and create a gap
 * cursor selection for them. The cursor is drawn as an element with class
 * `ProseMirror-gapcursor`.
 */

var GapCursorExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(GapCursorExtension, _Extension);

  function GapCursorExtension() {
    _classCallCheck(this, GapCursorExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(GapCursorExtension).apply(this, arguments));
  }

  _createClass(GapCursorExtension, [{
    key: "styles",

    /**
     * Sets the styling for the gapCursor.
     *
     * @remarks
     *
     * To override set `exclude.styles` to true and pass you desired `extraStyles` into the editor.
     *
     * ```ts
     * const extraStyles = css({ ...styles });
     * new GapCursorExtension({ exclude: {styled: true}, extraStyles });
     * ```
     *
     * Taken from https://github.com/ProseMirror/prosemirror-gapcursor/blob/d8dfba0aa58439ec840c0848c3a79cea7d33ea4f/style/gapcursor.css#L1-L25
     */
    value: function styles() {
      return css(_templateObject());
    }
    /**
     * Adds the gapCursor plugin functionality into the editor.
     */

  }, {
    key: "plugin",
    value: function plugin() {
      return gapCursor();
    }
  }, {
    key: "name",
    get: function get() {
      return 'gapCursor';
    }
  }]);

  return GapCursorExtension;
}(Extension);
/**
 * Predicate checking whether the selection is a GapCursor
 *
 * @param value - the value to check
 */

var isGapCursorSelection = isInstanceOf(GapCursor);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * This extension provides undo and redo commands and inserts a plugin which
 * handles history related actions.
 *
 * @builtin
 */
var HistoryExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(HistoryExtension, _Extension);

  function HistoryExtension() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HistoryExtension);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HistoryExtension)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "wrapMethod", function (method) {
      return function (state, dispatch, view) {
        var _this$options = _this.options,
            getState = _this$options.getState,
            getDispatch = _this$options.getDispatch;
        return method(getState ? getState() || state : state, getDispatch ? getDispatch() || dispatch : dispatch, view);
      };
    });

    return _this;
  }

  _createClass(HistoryExtension, [{
    key: "keys",

    /**
     * Adds the default key mappings for undo and redo.
     */
    value: function keys() {
      return _objectSpread$2({
        'Mod-y': function ModY() {
          return false;
        },
        'Mod-z': this.wrapMethod(undo),
        'Shift-Mod-z': this.wrapMethod(redo)
      }, !environment.isMac ? _defineProperty({}, 'Mod-y', this.wrapMethod(redo)) : {});
    }
    /**
     * Bring the `prosemirror-history` plugin with options set on this extension.
     */

  }, {
    key: "plugin",
    value: function plugin() {
      var _this$options2 = this.options,
          depth = _this$options2.depth,
          newGroupDelay = _this$options2.newGroupDelay;
      return history({
        depth: depth,
        newGroupDelay: newGroupDelay
      });
    }
    /**
     * Provides the isEnabled method to the ActionMethods of undo and redo.
     *
     * @remarks
     *
     * - Redo is not enabled when at the end of the history and there is nothing left to redo.
     * - Undo is not enabled when at the beginning of the history and there is nothing left to undo.
     */

  }, {
    key: "isEnabled",
    value: function isEnabled(_ref2) {
      var getState = _ref2.getState;
      return function (_ref3) {
        var command = _ref3.command;

        switch (command) {
          case 'undo':
            return undoDepth(getState()) > 0;

          case 'redo':
            return redoDepth(getState()) > 0;

          default:
            return false;
        }
      };
    }
    /**
     * The history plugin doesn't really have an active state.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      return function () {
        return false;
      };
    }
    /**
     * Provide the undo and redo commands.
     */

  }, {
    key: "commands",
    value: function commands() {
      var _this2 = this;

      return {
        /**
         * Undo the last action that occurred. This can be overridden by
         * setting an `"addToHistory"` metadata property of `false` on a
         * transaction to prevent it from being rolled back by undo.
         *
         * ```ts
         * actions.undo()
         *
         * // To prevent this use
         * tr.setMeta(pluginKey, { addToHistory: false })
         * ```
         */
        undo: function undo$1() {
          return _this2.wrapMethod(undo);
        },

        /**
         * Redo an action that was in the undo stack.
         *
         * ```ts
         * actions.redo()
         * ```
         */
        redo: function redo$1() {
          return _this2.wrapMethod(redo);
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'history';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        depth: 100,
        newGroupDelay: 500
      };
    }
    /**
     * Wraps the history method to inject state from the getState or getDispatch
     * method.
     *
     * @param method - the method to wrap
     */

  }]);

  return HistoryExtension;
}(Extension);

var findSpecialNodeAfter = function findSpecialNodeAfter($pos, tr, matchers) {
  if (nodeNameMatchesList($pos.nodeAfter, matchers)) {
    return $pos.pos + 1;
  }

  var parentOffset = $pos.parentOffset,
      parent = $pos.parent;
  var docSize = tr.doc.nodeSize - 2;

  if (parentOffset === parent.content.size && $pos.pos + 1 < docSize - 2) {
    var _tr$doc$resolve = tr.doc.resolve($pos.pos + 1),
        nodeAfter = _tr$doc$resolve.nodeAfter;

    if (nodeAfter && nodeNameMatchesList(nodeAfter.firstChild, matchers)) {
      return $pos.pos + 2;
    }
  }

  return;
};
var findSpecialNodeBefore = function findSpecialNodeBefore($pos, tr, matchers) {
  if (nodeNameMatchesList($pos.nodeBefore, matchers)) {
    return $pos.pos - 1;
  }

  if ($pos.pos === 0) {
    return;
  }

  var parentOffset = $pos.parentOffset;

  if (parentOffset === 0) {
    var _tr$doc$resolve2 = tr.doc.resolve($pos.pos - 1),
        nodeBefore = _tr$doc$resolve2.nodeBefore;

    if (nodeBefore && nodeNameMatchesList(nodeBefore.firstChild, matchers)) {
      return $pos.pos - 2;
    }
  }

  return;
};

var createNodeCursorExtensionPlugin = function createNodeCursorExtensionPlugin(ctx, nodeNames) {
  var targets = uniqueArray([].concat(_toConsumableArray(nodeNames), _toConsumableArray(ctx.options.targets)));
  return new Plugin({
    key: ctx.pluginKey,
    state: {
      init: function init() {
        return [];
      },
      apply: function apply(tr) {
        var selection = tr.selection;
        var $from = selection.$from;
        var positions = [];
        var posAfter = findSpecialNodeAfter($from, tr, targets);
        var posBefore = findSpecialNodeBefore($from, tr, targets);

        if (posAfter !== undefined) {
          positions.push(posAfter);
        }

        if (posBefore !== undefined) {
          positions.push(posBefore);
        }

        return positions;
      }
    },
    props: {
      decorations: function decorations(state) {
        var doc = state.doc;
        var positions = getPluginState(ctx.pluginKey, state);

        if (positions && positions.length) {
          var decorations = positions.map(function (position) {
            var node = document.createElement('span');
            node.appendChild(document.createTextNode(ZERO_WIDTH_SPACE_CHAR));
            return Decoration.widget(position, node, {
              raw: true,
              side: -1
            });
          });
          return DecorationSet.create(doc, decorations);
        }

        return null;
      }
    }
  });
};

/**
 * This extension makes it possible to navigate with the arrow keys between nodes.
 *
 * @remarks
 *
 * Without it the cursor sometimes gets lost and stops responding to key presses.
 */
var NodeCursorExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(NodeCursorExtension, _Extension);

  function NodeCursorExtension() {
    _classCallCheck(this, NodeCursorExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeCursorExtension).apply(this, arguments));
  }

  _createClass(NodeCursorExtension, [{
    key: "plugin",
    value: function plugin(_ref) {
      var tags = _ref.tags;
      return createNodeCursorExtensionPlugin(this, tags.general.nodeCursor);
    }
  }, {
    key: "name",
    get: function get() {
      return 'nodeCursor';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        targets: []
      };
    }
  }]);

  return NodeCursorExtension;
}(Extension);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Apply state for managing the created placeholder plugin
 *
 * @param params
 */
var applyState = function applyState(_ref) {
  var pluginState = _ref.pluginState,
      extension = _ref.extension,
      tr = _ref.tr,
      state = _ref.state;

  if (!tr.docChanged) {
    return pluginState;
  }

  return _objectSpread$3({}, extension.options, {
    empty: isDocNodeEmpty(state.doc)
  });
};
/**
 * Creates a decoration set from the passed through state
 *
 * @param params.extension
 * @param params.state
 */


var createDecorationSet = function createDecorationSet(_ref2) {
  var extension = _ref2.extension,
      state = _ref2.state;

  var _getPluginState = getPluginState(extension.pluginKey, state),
      empty = _getPluginState.empty;

  var _extension$options = extension.options,
      emptyNodeClass = _extension$options.emptyNodeClass,
      placeholder = _extension$options.placeholder;

  if (!empty) {
    return;
  }

  var decorations = [];
  state.doc.descendants(function (node, pos) {
    var decoration = Decoration.node(pos, pos + node.nodeSize, {
      class: emptyNodeClass,
      'data-placeholder': placeholder
    });
    decorations.push(decoration);
  });
  return DecorationSet.create(state.doc, decorations);
};
/**
 * Create the placeholder plugin
 *
 * @param extension
 */


var createPlaceholderPlugin = function createPlaceholderPlugin(extension) {
  return new Plugin({
    key: extension.pluginKey,
    state: {
      init: function init(_, state) {
        return _objectSpread$3({}, extension.options, {
          empty: isDocNodeEmpty(state.doc)
        });
      },
      apply: function apply(tr, pluginState, _, state) {
        return applyState({
          pluginState: pluginState,
          tr: tr,
          extension: extension,
          state: state
        });
      }
    },
    props: {
      decorations: function decorations(state) {
        return createDecorationSet({
          state: state,
          extension: extension
        });
      }
    }
  });
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PlaceholderExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(PlaceholderExtension, _Extension);

  function PlaceholderExtension() {
    _classCallCheck(this, PlaceholderExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlaceholderExtension).apply(this, arguments));
  }

  _createClass(PlaceholderExtension, [{
    key: "styles",
    value: function styles() {
      var selector = ".".concat(this.options.emptyNodeClass, ":first-of-type::before");
      return ["\n       ".concat(selector, " {\n        position: absolute;\n        color: #aaa;\n        pointer-events: none;\n        height: 0;\n        font-style: italic;\n        content: attr(data-placeholder);\n      }\n    "), _defineProperty({}, selector, this.options.placeholderStyle)];
    }
  }, {
    key: "plugin",
    value: function plugin() {
      return createPlaceholderPlugin(this);
    }
    /**
     * When the view becomes available set the aria placeholder property.
     */

  }, {
    key: "attributes",
    value: function attributes() {
      return {
        'aria-placeholder': this.options.placeholder
      };
    }
    /**
     * Add a class and props to the root element if the document is empty.
     */

  }, {
    key: "ssrTransformer",
    value: function ssrTransformer(element, _ref2) {
      var getState = _ref2.getState;
      var state = getState();
      var _this$options = this.options,
          emptyNodeClass = _this$options.emptyNodeClass,
          placeholder = _this$options.placeholder;

      var _getElementProps = getElementProps(element),
          children = _getElementProps.children;

      if (Children.count(children) > 1 || !isDocNodeEmpty(state.doc)) {
        return element;
      }

      var props = getElementProps(children);
      return cloneElement(element, {}, cloneElement(children, _objectSpread$4({}, props, {
        className: props.className ? "".concat(props.className, " ").concat(emptyNodeClass) : emptyNodeClass,
        'data-placeholder': placeholder
      })));
    }
  }, {
    key: "name",
    get: function get() {
      return 'placeholder';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        emptyNodeClass: EMPTY_NODE_CLASS_NAME,
        placeholderStyles: {},
        placeholder: ''
      };
    }
  }]);

  return PlaceholderExtension;
}(Extension);

var CLEAR = Symbol('CLEAR');
var defaultPositionTrackerExtensionOptions = {
  defaultClassName: 'remirror-tracker-position',
  defaultElement: 'tracker'
};

/**
 * Applies a placeholder to a position in the document for actions that might take a while to complete.
 *
 * An example of this would be uploading an image. From when the upload starts to when it
 * finally completes a lot can happen in the editor. This extension and it's helper functions
 * allow the editor to keep track of where the image should actually be inserted.
 */
var PositionTrackerExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(PositionTrackerExtension, _Extension);

  function PositionTrackerExtension() {
    _classCallCheck(this, PositionTrackerExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(PositionTrackerExtension).apply(this, arguments));
  }

  _createClass(PositionTrackerExtension, [{
    key: "helpers",
    value: function helpers(_ref) {
      var _this = this;

      var getState = _ref.getState;
      var helpers = {
        /**
         * Add a tracker position with the specified params to the transaction and return the transaction.
         *
         * It is up to you to dispatch the transaction or you can just use the commands.
         */
        addPositionTracker: function addPositionTracker(_ref2) {
          var pos = _ref2.pos,
              id = _ref2.id;
          var tr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getState().tr;
          var existingPosition = helpers.findPositionTracker(id);

          if (existingPosition) {
            return;
          }

          return tr.setMeta(_this.pluginKey, {
            add: {
              id: id,
              pos: isNumber(pos) ? pos : tr.selection.from
            }
          });
        },

        /**
         * Discards a previously defined tracker once not needed.
         *
         * This should be used to cleanup once the position is no longer needed.
         */
        removePositionTracker: function removePositionTracker(_ref3) {
          var id = _ref3.id;
          var tr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getState().tr;
          var existingPosition = helpers.findPositionTracker(id);

          if (!existingPosition) {
            return;
          }

          return tr.setMeta(_this.pluginKey, {
            remove: {
              id: id
            }
          });
        },

        /**
         * This helper returns a transaction that clears all position tracker when any exist.
         *
         * Otherwise it returns undefined.
         */
        clearPositionTrackers: function clearPositionTrackers() {
          var tr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getState().tr;
          var positionTrackerState = getPluginState(_this.pluginKey, getState());

          if (positionTrackerState === DecorationSet.empty) {
            return;
          }

          return tr.setMeta(_this.pluginKey, {
            clear: CLEAR
          });
        },

        /**
         * Find the position for the tracker with the ID specified.
         *
         * @param id - the unique position id which can be any type
         */
        findPositionTracker: function findPositionTracker(id) {
          var decorations = getPluginState(_this.pluginKey, getState());
          var found = decorations.find(undefined, undefined, function (spec) {
            return spec.id === id;
          });
          return found.length ? found[0].from : undefined;
        },

        /**
         * Find the positions of all the trackers.in the decoration set.
         *
         * @param id - the unique position id which can be any type
         */
        findAllPositionTrackers: function findAllPositionTrackers() {
          var trackers = Object.create(null);
          var decorations = getPluginState(_this.pluginKey, getState());
          var found = decorations.find(undefined, undefined, function (spec) {
            return spec.type === _this.name;
          });
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = found[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var decoration = _step.value;
              trackers[decoration.spec.id] = decoration.from;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return trackers;
        }
      };
      return helpers;
    }
  }, {
    key: "commands",
    value: function commands(_ref4) {
      var getHelpers = _ref4.getHelpers;

      var commandFactory = function commandFactory(helperName) {
        return function (params) {
          return function (_, dispatch) {
            var helper = getHelpers(helperName);
            var tr = helper(params); // Nothing changed therefore do nothing

            if (!tr) {
              return false;
            }

            if (dispatch) {
              dispatch(tr);
            }

            return true;
          };
        };
      };

      return {
        /**
         * Command to dispatch a transaction adding the tracker position to be tracked.
         * If no position parameter is specified it uses the current position.
         */
        addPositionTracker: commandFactory('addPositionTracker'),

        /**
         * A command to remove the specified tracker position.
         */
        removePositionTracker: commandFactory('removePositionTracker'),

        /**
         * A command to remove all active tracker positions.
         */
        clearPositionTrackers: commandFactory('clearPositionTrackers')
      };
    }
  }, {
    key: "plugin",
    value: function plugin() {
      var _this2 = this;

      var key = this.pluginKey;
      var name = this.name;
      return new Plugin({
        key: key,
        state: {
          init: function init() {
            return DecorationSet.empty;
          },
          apply: function apply(tr, decorationSet) {
            // Map the decoration based on the changes to the document.
            decorationSet = decorationSet.map(tr.mapping, tr.doc); // Get tracker updates from the meta data

            var tracker = getPluginMeta(key, tr);

            if (!tracker) {
              return decorationSet;
            }

            if (tracker.add) {
              var _widget$classList;

              var _this2$options = _this2.options,
                  defaultClassName = _this2$options.defaultClassName,
                  defaultElement = _this2$options.defaultElement;
              var _tracker$add = tracker.add,
                  className = _tracker$add.className,
                  _tracker$add$element = _tracker$add.element,
                  element = _tracker$add$element === void 0 ? defaultElement : _tracker$add$element;
              var widget = isString$1(element) ? document.createElement(element) : element;
              var classNames = className ? [defaultClassName, className] : [defaultClassName];

              (_widget$classList = widget.classList).add.apply(_widget$classList, classNames);

              var deco = Decoration.widget(tracker.add.pos, widget, {
                id: tracker.add.id,
                type: name
              });
              return decorationSet.add(tr.doc, [deco]);
            }

            if (tracker.remove) {
              var remove = tracker.remove;
              var found = decorationSet.find(undefined, undefined, function (spec) {
                return spec.id === remove.id;
              });
              return decorationSet.remove(found);
            }

            if (tracker.clear === CLEAR) {
              return DecorationSet.empty;
            }

            return decorationSet;
          }
        },
        props: {
          decorations: function decorations(state) {
            return getPluginState(key, state);
          }
        }
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'positionTracker';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultPositionTrackerExtensionOptions;
    }
  }]);

  return PositionTrackerExtension;
}(Extension);

/**
 * A function that transforms the element received during Server Side Rendering
 */

/**
 * Clone SSR elements ignoring the top level Fragment
 *
 * @remarks
 * A utility method for the SSR JSX
 *
 * @param element - the element to transform which must be from the JSX received in `ssrTransformer`
 * @param transformChildElements - receives the nested elements and props and transforms them into another JSX.Element
 */
var cloneSSRElement = function cloneSSRElement(element, transformChildElements) {
  if (!isReactFragment(element)) {
    throw new Error('Invalid element passed. The top level element must be a fragment');
  }

  var _getElementProps = getElementProps(element),
      children = _getElementProps.children;

  var childrenProps = getElementProps(children);
  return cloneElement(element, {}, transformChildElements(children, childrenProps));
};
/**
 * Returns true when a react element has no children.
 *
 * @param element - the element to test
 */

var elementIsEmpty = function elementIsEmpty(element) {
  return Children.count(element.props.children) === 0;
};
/**
 * Checks to see that the element is of the provided type.
 *
 * @param element - the element to test
 * @param type - the type to match
 */


var elementIsOfType = function elementIsOfType(element, type) {
  return element.type === type;
};
/**
 * This utility maps through the SSR element and injects break tags into all empty p tags.
 *
 * @remarks
 * Prosemirror automatically injects break tags into empty paragraph tags. This causes the document
 * rendered during SSR to be different than when the page loads.
 */


var injectBrIntoEmptyParagraphs = function injectBrIntoEmptyParagraphs(element) {
  return cloneSSRElement(element, function (children) {
    if (!isArray(children)) {
      return children;
    }

    return Children.map(children, function (child) {
      if (!(isReactDOMElement(child) && elementIsEmpty(child) && elementIsOfType(child, 'p'))) {
        return child;
      }

      var props = getElementProps(child);
      return cloneElement(child, props, jsx('br'));
    });
  });
};
/**
 * The default transformations which are applied when none are passed.
 */

var DEFAULT_TRANSFORMATIONS = [injectBrIntoEmptyParagraphs];

/**
 * This extension makes it easier to add SSR transformations to the editor.
 *
 * @remarks
 *
 * There are subtle things that prosemirror does when it loads the document that can cause things to jump around.
 *
 * The aim of this extension is to provide a series of helper transformations which deal with the typical problems
 * that prosemirror presents when rendering on the server.
 *
 * The transformations can also serve as a guideline when creating your own SSRTransforms. However in most cases the
 * defaults should be sufficient.
 */
var SSRHelperExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(SSRHelperExtension, _Extension);

  function SSRHelperExtension() {
    _classCallCheck(this, SSRHelperExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(SSRHelperExtension).apply(this, arguments));
  }

  _createClass(SSRHelperExtension, [{
    key: "ssrTransformer",

    /**
     * Runs through all the provided transformations for changing the rendered SSR component.
     */
    value: function ssrTransformer(element, params) {
      return this.options.transformers.reduce(function (transformedElement, transformer) {
        return transformer(transformedElement, params);
      }, element);
    }
  }, {
    key: "name",
    get: function get() {
      return 'ssrHelper';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        transformers: DEFAULT_TRANSFORMATIONS
      };
    }
  }]);

  return SSRHelperExtension;
}(Extension);

var defaultTrailingNodeExtensionOptions = {
  ignoredNodes: [],
  disableTags: false,
  nodeName: 'paragraph'
};
/**
 * Ensure that there's always a trailing paragraph at the end of the document.
 *
 * Why? In some scenarios it is difficult to place a cursor after the last element.
 * This ensures there's always space to select the position afterward.
 *
 * @defaultValue false
 */

var TrailingNodeExtension =
/*#__PURE__*/
function (_Extension) {
  _inherits(TrailingNodeExtension, _Extension);

  function TrailingNodeExtension() {
    _classCallCheck(this, TrailingNodeExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrailingNodeExtension).apply(this, arguments));
  }

  _createClass(TrailingNodeExtension, [{
    key: "plugin",

    /**
     * Register the plugin which is responsible for inserting the configured node
     * into the end of the node.
     */
    value: function plugin(_ref) {
      var tags = _ref.tags,
          schema = _ref.schema;
      return createTrailingNodePlugin({
        extension: this,
        tags: tags,
        schema: schema
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'trailingNode';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultTrailingNodeExtensionOptions;
    }
  }]);

  return TrailingNodeExtension;
}(Extension);

/**
 * Create the paragraph plugin which can check the end of the document and
 * insert a new node.
 */
var createTrailingNodePlugin = function createTrailingNodePlugin(_ref2) {
  var extension = _ref2.extension,
      tags = _ref2.tags,
      schema = _ref2.schema;
  var options = extension.options,
      pluginKey = extension.pluginKey;
  var disableTags = options.disableTags,
      ignoredNodes = options.ignoredNodes,
      nodeName = options.nodeName; // The names of the nodes for whom this rule should not be applied.

  var notAfter = disableTags ? uniqueArray$1([].concat(_toConsumableArray(ignoredNodes), [nodeName])) : uniqueArray$1([].concat(_toConsumableArray(ignoredNodes), _toConsumableArray(tags.general.lastNodeCompatible), [nodeName])); // The node that will be inserted when the criteria match.

  var type = schema.nodes[nodeName]; // The list of nodes for this schema that should have content injected after
  // them.

  var types = entries(schema.nodes).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        entry = _ref4[1];

    return entry;
  }).filter(function (entry) {
    return !notAfter.includes(entry.name);
  });
  return new Plugin({
    key: extension.pluginKey,
    view: function view() {
      return {
        update: function update(view) {
          var state = view.state,
              dispatch = view.dispatch;
          var doc = state.doc;
          var shouldInsertNodeAtEnd = getPluginState(pluginKey, state);
          var endPosition = doc.content.size;

          if (!shouldInsertNodeAtEnd) {
            return;
          }

          dispatch(state.tr.insert(endPosition, type.create()));
        }
      };
    },
    state: {
      init: function init(_, state) {
        var node = state.tr.doc.lastChild;
        return nodeEqualsType({
          node: node,
          types: types
        });
      },
      apply: function apply(tr, state) {
        if (!tr.docChanged) {
          return state;
        }

        var node = tr.doc.lastChild;
        return nodeEqualsType({
          node: node,
          types: types
        });
      }
    }
  });
};

var BlockquoteExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(BlockquoteExtension, _NodeExtension);

  function BlockquoteExtension() {
    _classCallCheck(this, BlockquoteExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockquoteExtension).apply(this, arguments));
  }

  _createClass(BlockquoteExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return {
        /**
         * Toggle the blockquote at the current selection.
         *
         * If none exists one will be created or the existing blockquote content will be
         * lifted out of the blockquote node.
         *
         * ```ts
         * actions.blockquote();
         * ```
         */
        blockquote: function blockquote() {
          return toggleWrap(type);
        }
      };
    }
  }, {
    key: "styles",
    value: function styles() {
      return "".concat(EDITOR_CLASS_SELECTOR, " blockquote {\n      border-left: 2px solid #ddd;\n      margin-left: 0;\n      margin-right: 0;\n      padding-left: 10px;\n      font-style: italic;\n    }\n    ").concat(EDITOR_CLASS_SELECTOR, " blockquote p {\n      color: #888;\n    }\n    ");
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      return {
        'Ctrl->': toggleWrap(type)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [wrappingInputRule(/^\s*>\s$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'blockquote';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        content: 'block*',
        group: NodeGroup.Block,
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'blockquote'
        }],
        toDOM: function toDOM() {
          return ['blockquote', 0];
        }
      };
    }
  }]);

  return BlockquoteExtension;
}(NodeExtension);

var BulletListExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(BulletListExtension, _NodeExtension);

  function BulletListExtension() {
    _classCallCheck(this, BulletListExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(BulletListExtension).apply(this, arguments));
  }

  _createClass(BulletListExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        toggleBulletList: function toggleBulletList() {
          return toggleList(type, schema.nodes.listItem);
        }
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        'Shift-Ctrl-8': toggleList(type, schema.nodes.listItem)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [wrappingInputRule(/^\s*([-+*])\s$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'bulletList';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        content: 'listItem+',
        group: NodeGroup.Block,
        parseDOM: [{
          tag: 'ul'
        }],
        toDOM: function toDOM() {
          return ['ul', 0];
        }
      };
    }
  }]);

  return BulletListExtension;
}(NodeExtension);

var CodeBlockExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(CodeBlockExtension, _NodeExtension);

  function CodeBlockExtension() {
    _classCallCheck(this, CodeBlockExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeBlockExtension).apply(this, arguments));
  }

  _createClass(CodeBlockExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        toggleCodeBlock: function toggleCodeBlock() {
          return toggleBlockItem({
            type: type,
            toggleType: schema.nodes.paragraph
          });
        }
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        'Shift-Ctrl-\\': toggleBlockItem({
          type: type,
          toggleType: schema.nodes.paragraph
        })
      };
    }
  }, {
    key: "styles",
    value: function styles() {
      var _ref3;

      return _ref3 = {}, _defineProperty(_ref3, "".concat(EDITOR_CLASS_SELECTOR, " pre"), {
        backgroundColor: '#000',
        borderRadius: '5px',
        padding: '.7rem 1rem',
        color: '#fff',
        fontSize: '.8rem',
        overflowX: 'auto'
      }), _defineProperty(_ref3, "".concat(EDITOR_CLASS_SELECTOR, " pre code"), {
        display: 'block'
      }), _ref3;
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref4) {
      var type = _ref4.type;
      return [textblockTypeInputRule(/^```$/, type)];
    }
  }, {
    key: "name",
    get: function get() {
      return 'codeBlock';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        content: 'text*',
        marks: '',
        group: NodeGroup.Block,
        code: true,
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'pre',
          preserveWhitespace: 'full'
        }],
        toDOM: function toDOM() {
          return ['pre', ['code', 0]];
        }
      };
    }
  }]);

  return CodeBlockExtension;
}(NodeExtension);

var HardBreakExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(HardBreakExtension, _NodeExtension);

  function HardBreakExtension() {
    _classCallCheck(this, HardBreakExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(HardBreakExtension).apply(this, arguments));
  }

  _createClass(HardBreakExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      var command = chainCommands(exitCode, function (state, dispatch) {
        if (dispatch) {
          dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
        }

        return true;
      });
      return {
        'Mod-Enter': command,
        'Shift-Enter': command
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'hardBreak';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        inline: true,
        group: 'inline',
        selectable: false,
        parseDOM: [{
          tag: 'br'
        }],
        toDOM: function toDOM() {
          return ['br'];
        }
      };
    }
  }]);

  return HardBreakExtension;
}(NodeExtension);

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultHeadingExtensionOptions = {
  levels: [1, 2, 3, 4, 5, 6],
  defaultLevel: 1
};
var HeadingExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(HeadingExtension, _NodeExtension);

  function HeadingExtension() {
    _classCallCheck(this, HeadingExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeadingExtension).apply(this, arguments));
  }

  _createClass(HeadingExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        /**
         * Toggle the heading for the current block.
         */
        toggleHeading: function toggleHeading(attrs) {
          return toggleBlockItem({
            type: type,
            toggleType: schema.nodes.paragraph,
            attrs: attrs
          });
        }
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      var keys = Object.create(null);
      this.options.levels.forEach(function (level) {
        keys["Shift-Ctrl-".concat(level)] = setBlockType(type, {
          level: level
        });
      });
      return keys;
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return this.options.levels.map(function (level) {
        return textblockTypeInputRule(new RegExp("^(#{1,".concat(level, "})\\s$")), type, function () {
          return {
            level: level
          };
        });
      });
    }
  }, {
    key: "name",
    get: function get() {
      return 'heading';
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultHeadingExtensionOptions;
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        attrs: _objectSpread$5({}, this.extraAttrs(null), {
          level: {
            default: this.options.defaultLevel
          }
        }),
        content: 'inline*',
        group: NodeGroup.Block,
        defining: true,
        draggable: false,
        parseDOM: this.options.levels.map(function (level) {
          return {
            tag: "h".concat(level),
            attrs: {
              level: level
            }
          };
        }),
        toDOM: function toDOM(node) {
          if (!_this.options.levels.includes(node.attrs.level)) {
            // Use the first level available
            return ["h".concat(_this.options.defaultLevel), 0];
          }

          return ["h".concat(node.attrs.level), 0];
        }
      };
    }
  }]);

  return HeadingExtension;
}(NodeExtension);

var ListItemExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(ListItemExtension, _NodeExtension);

  function ListItemExtension() {
    _classCallCheck(this, ListItemExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItemExtension).apply(this, arguments));
  }

  _createClass(ListItemExtension, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        Enter: splitListItem(type),
        Tab: sinkListItem(type),
        'Shift-Tab': liftListItem(type)
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'listItem';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        content: 'paragraph block*',
        defining: true,
        draggable: false,
        parseDOM: [{
          tag: 'li'
        }],
        toDOM: function toDOM() {
          return ['li', 0];
        }
      };
    }
  }]);

  return ListItemExtension;
}(NodeExtension);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var OrderedListExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(OrderedListExtension, _NodeExtension);

  function OrderedListExtension() {
    _classCallCheck(this, OrderedListExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderedListExtension).apply(this, arguments));
  }

  _createClass(OrderedListExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return {
        toggleOrderedList: function toggleOrderedList() {
          return toggleList(type, schema.nodes.listItem);
        }
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        'Shift-Ctrl-9': toggleList(type, schema.nodes.listItem)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [wrappingInputRule(/^(\d+)\.\s$/, type, function (match) {
        return {
          order: +match[1]
        };
      }, function (match, node) {
        return node.childCount + node.attrs.order === +match[1];
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'orderedList';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: _objectSpread$6({
          order: {
            default: 1
          }
        }, this.extraAttrs()),
        content: 'listItem+',
        group: NodeGroup.Block,
        parseDOM: [{
          tag: 'ol',
          getAttrs: function getAttrs(node) {
            return {
              order: Cast(node).hasAttribute('start') ? +Cast(node).getAttribute('start') : 1
            };
          }
        }],
        toDOM: function toDOM(node) {
          return node.attrs.order === 1 ? ['ol', 0] : ['ol', {
            start: node.attrs.order
          }, 0];
        }
      };
    }
  }]);

  return OrderedListExtension;
}(NodeExtension);

var HorizontalRuleExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(HorizontalRuleExtension, _NodeExtension);

  function HorizontalRuleExtension() {
    _classCallCheck(this, HorizontalRuleExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(HorizontalRuleExtension).apply(this, arguments));
  }

  _createClass(HorizontalRuleExtension, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type;
      return {
        horizontalRule: function horizontalRule() {
          return function (state, dispatch) {
            if (dispatch) {
              dispatch(state.tr.replaceSelectionWith(type.create()));
            }

            return true;
          };
        }
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref2) {
      var type = _ref2.type;
      return [nodeInputRule({
        regexp: /^(?:---|___\s|\*\*\*\s)$/,
        type: type
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return 'horizontalRule';
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        attrs: this.extraAttrs(),
        group: NodeGroup.Block,
        parseDOM: [{
          tag: 'hr'
        }],
        toDOM: function toDOM() {
          return ['hr'];
        }
      };
    }
  }]);

  return HorizontalRuleExtension;
}(NodeExtension);

/**
 * The size of the default indentation size (in pt).
 */
var INDENT_MARGIN_PT_SIZE = 36;
/**
 * The levels of indentation supported by default. Can be overridden.
 */

var INDENT_LEVELS = [0, 7];
/**
 * The min indentation level.
 */

var MIN_INDENT_LEVEL = 0;
/**
 * The default maximum level of indentation allowed.
 */

var MAX_INDENT_LEVEL = 7;
/**
 * The attribute to use for storing the indent value.
 */

var INDENT_ATTRIBUTE = 'data-indent';
/**
 * Values which can safely be ignored when styling nodes.
 */

var EMPTY_CSS_VALUE = new Set(['', '0%', '0pt', '0px']);
/**
 * The default line spacing values.
 */

var LINE_SPACING_VALUES = ['100%', '115%', '150%', // Default value.
'200%'];
/**
 * Regex for accepting a value as a valid alignment name.
 */

var ALIGN_PATTERN = /(left|right|center|justify)/;
/**
 * Regex for matching sizes in the DOM.
 */

var SIZE_PATTERN = /([\d\.]+)(px|pt)/i;
/**
 * The default pixel to pt font size ratio.
 *
 * @see https://github.com/chanzuckerberg/czi-prosemirror/blob/52e34840d73fccc46637314bf4b4be71147112d4/src/convertToCSSPTValue.js#L7
 */

var PIXEL_TO_PT_RATIO = 0.7518796992481203; // 1 / 1.33.

/**
 * The default pt to pixel ratio.
 */

var PT_TO_PIXEL_RATIO = 1.33;
/**
 * The default font sizes for the editor.
 */

var FONT_PT_SIZES = [8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 90];
var CSS_ROTATE_PATTERN = /rotate\(([0-9\.]+)rad\)/i;

/**
 * Converts a style value for size into into the same `pt`.
 *
 * TODO is it really important to make fonts print media friendly?
 */
var convertToPt = function convertToPt(styleValue) {
  var matches = styleValue.match(SIZE_PATTERN);

  if (!matches) {
    return 0;
  }

  var value = parseFloat(matches[1]);
  var unit = matches[2];

  if (!value || !unit) {
    return 0;
  }

  if (unit === 'px') {
    value = PIXEL_TO_PT_RATIO * value;
  }

  return value;
};
/**
 * Converts the left margin into an indentation level.
 */

var marginToIndent = function marginToIndent(marginLeft) {
  var levels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INDENT_LEVELS;
  var ptValue = convertToPt(marginLeft);
  var min = levels[0];
  var max = levels[1];
  var value = Math.floor(ptValue / INDENT_MARGIN_PT_SIZE);
  return clamp({
    min: min,
    max: max,
    value: value
  });
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * The paragraph is one of the essential building blocks for a prosemirror
 * editor and by default it is provided to all editors.
 *
 * @builtin
 */
var ParagraphExtension =
/*#__PURE__*/
function (_NodeExtension) {
  _inherits(ParagraphExtension, _NodeExtension);

  function ParagraphExtension() {
    _classCallCheck(this, ParagraphExtension);

    return _possibleConstructorReturn(this, _getPrototypeOf(ParagraphExtension).apply(this, arguments));
  }

  _createClass(ParagraphExtension, [{
    key: "commands",

    /**
     * Provides the commands that this extension uses.
     */
    value: function commands(_ref) {
      var type = _ref.type;
      return {
        createParagraph: function createParagraph(attrs) {
          return setBlockType(type, attrs);
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'paragraph';
    }
  }, {
    key: "tags",
    get: function get() {
      return [Tags.LastNodeCompatible];
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        indentAttribute: INDENT_ATTRIBUTE,
        indentLevels: INDENT_LEVELS
      };
    }
  }, {
    key: "schema",
    get: function get() {
      var _this = this;

      return {
        content: 'inline*',
        group: NodeGroup.Block,
        attrs: _objectSpread$7({}, this.extraAttrs(), {
          align: {
            default: null
          },
          id: {
            default: null
          },
          indent: {
            default: 0
          },
          lineSpacing: {
            default: null
          }
        }),
        draggable: false,
        parseDOM: [{
          tag: 'p',
          getAttrs: function getAttrs(node) {
            return _objectSpread$7({}, _this.getExtraAttrs(node), {}, _getAttrs(_this.options, node));
          }
        }],
        toDOM: function toDOM(node) {
          var _ref2 = node.attrs,
              align = _ref2.align,
              indent = _ref2.indent,
              lineSpacing = _ref2.lineSpacing,
              id = _ref2.id;
          var attrs = Object.create(null);
          var style = '';

          if (align && align !== 'left') {
            style += "text-align: ".concat(align, ";");
          }

          if (lineSpacing) {
            style += "line-height: ".concat(lineSpacing, ";");
          }

          if (style) {
            attrs.style = style;
          }

          if (indent) {
            attrs[INDENT_ATTRIBUTE] = String(indent);
          }

          if (id) {
            attrs.id = id;
          }

          return ['p', attrs, 0];
        }
      };
    }
  }]);

  return ParagraphExtension;
}(NodeExtension);
/**
 * Pull the paragraph attributes from the dom element.
 */

var _getAttrs = function _getAttrs(_ref3, dom) {
  var indentAttribute = _ref3.indentAttribute,
      indentLevels = _ref3.indentLevels;
  var _dom$style = dom.style,
      lineHeight = _dom$style.lineHeight,
      textAlign = _dom$style.textAlign,
      marginLeft = _dom$style.marginLeft;
  var align = dom.getAttribute('align') || textAlign || '';
  var indent = parseInt(dom.getAttribute(indentAttribute) || '0', 10);
  align = ALIGN_PATTERN.test(align) ? align : undefined;

  if (!indent && marginLeft) {
    indent = marginToIndent(marginLeft);
  }

  indent = indent || indentLevels[0];
  var lineSpacing = lineHeight ? lineHeight : undefined;
  var id = dom.getAttribute('id') || undefined;
  return {
    align: align,
    indent: indent,
    lineSpacing: lineSpacing,
    id: id
  };
};

/**
 * Base extensions are automatically injected into the default RemirrorEditor.
 *
 * To override them, you can either add your own extension with the same extensionName
 * or you can turn off all of the base extensions.
 */

var baseExtensions = [{
  extension: new DocExtension(),
  priority: 1
}, {
  extension: new TextExtension(),
  priority: 1
}, {
  extension: new ParagraphExtension(),
  priority: 2
}, {
  extension: new HistoryExtension(),
  priority: 3
}, {
  extension: new CompositionExtension(),
  priority: 4
}, {
  extension: new GapCursorExtension(),
  priority: 10
}, {
  extension: new DropCursorExtension(),
  priority: 11
}, {
  extension: new BaseKeymapExtension(),
  priority: 12
}];
/**
 * The BaseExtensions union type shows the extension types available as base extensions.
 *
 * This union type is useful when paired with your own types to provide better typechecking
 * throughout your codebase.
 */

export { ALIGN_PATTERN, BaseKeymapExtension, BlockquoteExtension, BoldExtension, BulletListExtension, CSS_ROTATE_PATTERN, CodeBlockExtension, CodeExtension, CompositionExtension, DEFAULT_TRANSFORMATIONS, DropCursorExtension, EMPTY_CSS_VALUE, EMPTY_NODE_CLASS_NAME, EMPTY_NODE_CLASS_SELECTOR, FONT_PT_SIZES, GapCursorExtension, HardBreakExtension, HeadingExtension, HistoryExtension, HorizontalRuleExtension, INDENT_ATTRIBUTE, INDENT_LEVELS, INDENT_MARGIN_PT_SIZE, ItalicExtension, LINE_SPACING_VALUES, LinkExtension, ListItemExtension, MAX_INDENT_LEVEL, MIN_INDENT_LEVEL, NODE_CURSOR_DEFAULTS, NodeCursorExtension, OrderedListExtension, PIXEL_TO_PT_RATIO, PT_TO_PIXEL_RATIO, ParagraphExtension, PlaceholderExtension, PositionTrackerExtension, SIZE_PATTERN, SSRHelperExtension, StrikeExtension, TrailingNodeExtension, UnderlineExtension, baseExtensions, cloneSSRElement, convertToPt, createTrailingNodePlugin, defaultBaseKeymapExtensionOptions, defaultDropCursorExtensionOptions, defaultHeadingExtensionOptions, defaultTrailingNodeExtensionOptions, findSpecialNodeAfter, findSpecialNodeBefore, injectBrIntoEmptyParagraphs, isGapCursorSelection, marginToIndent };
//# sourceMappingURL=core-extensions.esm.js.map
